// ============================================================
// Icon
// ------------------------------------------------------------
// ไอคอนจากฟอนต์ FontAwesome Light (ส่งอักขระ unicode เข้ามาทาง prop icon)
// ใช้: <Icon icon={""} size={20} color="primary" />
// ============================================================

import React, { Component } from "react";

export default class Icon extends Component {
  render() {
    return (
      <span
        className={"icon-light" + (this.props.color ? " text-" + this.props.color : " text-dark") + (this.props.className ? " " + this.props.className : "")}
        style={{ fontSize: this.props.size ? this.props.size : 16 }}
      >
        {this.props.icon}
      </span>
    );
  }
}
